import type { WalletRecoveryState } from '@dynamic-labs-wallet/browser-wallet-client';

import { getDefaultClient } from '../../../client/defaultClient';
import type { DynamicClient } from '../../../client/types/DynamicClient';
import type { WalletAccount } from '../../wallets/walletAccount';
import { getWaasWalletProviderFromWalletAccount } from '../getWaasWalletProviderFromWalletAccount';

type GetWalletRecoveryStateParams = {
  walletAccount: WalletAccount;
};

/**
 * Retrieves the recovery state of a WaaS wallet account.
 *
 * @param params.walletAccount - The WaaS wallet account to get the recovery state for.
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A promise that resolves with the wallet recovery state.
 */
export const getWalletRecoveryState = async (
  { walletAccount }: GetWalletRecoveryStateParams,
  client: DynamicClient = getDefaultClient()
): Promise<WalletRecoveryState> => {
  const provider = getWaasWalletProviderFromWalletAccount(
    { walletAccount },
    client
  );

  return provider.getWalletRecoveryState({
    walletAccount,
  });
};
